module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.visible) ? _c('div', {
    staticClass: "mask",
    staticStyle: {
      "z-index": "900"
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "confirm-scale"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "app-confirm",
    staticStyle: {
      "z-index": "901"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancel))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onOK
    }
  }, [_vm._v(_vm._s(_vm.ok))])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9711643a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/components/AppConfirm.vue
// module id = 340
// module chunks = 0